<script setup lang="ts">
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import ThePremium from '@/components/ThePremium.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import FastForwardImage from '@/assets/images/fast-forward.png'

defineProps<{
  show: boolean,
}>()

defineEmits<{
  (e: 'hide'): void
}>()

//TODO: get the real remaining hours
const hoursRemained = 12

function onBuy() {
//TODO: Discuss with Krisztina
}
</script>
<template>
  <TheBottomSheet
    :show="show"
    centered
    content-class="pt-8"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col gap-y-6">
      <h2 class="text-solid-white text-xl [440px]:text-2xl -tracking-[0.48px] font-bold">
        <T
          key-name="lingo.giveaway.hatch.title"
          default-value="You can’t hatch the egg yet"
        />
      </h2>
      <div class=" fle flex-col gap-y-1">
        <h2 class="text-solid-white text-lg -tracking-[0.36px] font-bold whitespace-break-spaces">
          <T
            key-name="lingo.giveaway.hatch.wait.title"
            default-value="⏳  Wait for the next hatch"
          />
        </h2>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="lingo.giveaway.hatch.wait.description"
            default-value="Wait {count, plural, one {# hour} other {# hours}} to make your next daily transaction.."
            :params="{
              count: hoursRemained
            }"
          />
        </p>
      </div>
      <div class=" fle flex-col gap-y-1">
        <div class=" flex items-center gap-x-2">
          <img
            class="w-6 h-6 min-w-6"
            :src="FastForwardImage"
          >
          <h2
            class="text-solid-white text-lg -tracking-[0.36px] font-bold whitespace-break-spaces"
          >
            <T
              key-name="lingo.giveaway.hatch.stars.title"
              default-value="Fast-forward with stars"
            />
          </h2>
        </div>
        <p class="text-base font-medium text-white/60 whitespace-pre-line">
          <T
            key-name="lingo.giveaway.hatch.stars.description"
            default-value="Use Telegram stars to reset the timer and hatch another egg instantly!"
          />
        </p>
      </div>

      <BaseButton @click="onBuy">
        <template #leftIcon>
          <ThePremium
            image-class="size-5 min-w-[20px]"
            :with-tooltip="false"
          />
        </template>
        <T
          key-name="fortune_wheel.buy_more_spins"
          default-value="Buy more spins"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
